import { render, staticRenderFns } from "./ProfileGroup.vue?vue&type=template&id=200e08ab&scoped=true&lang=html&"
import script from "./ProfileGroup.vue?vue&type=script&lang=js&"
export * from "./ProfileGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGroup.vue?vue&type=style&index=0&id=200e08ab&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e08ab",
  null
  
)

export default component.exports